import { getAssessmentUUIDsFromWikiText } from '@/util/tokenize_wiki_text'

export function getAllAssessmentUUIDs(summaryTexts: string[]): string[] {
    const allUUIDs = summaryTexts.flatMap(text => getAssessmentUUIDsFromWikiText(text))
    return [...new Set(allUUIDs)]
}
